<template>
  <div class="bg-gray-900 text-white p-6 h-screen flex flex-col justify-center items-center">
    
    <!-- انتخاب زبان -->
    <div class="mb-6 w-full max-w-md">
      <select v-model="selectedLanguage" @change="changeLanguage" class="bg-gray-800 text-white p-2 rounded-lg w-full">
        <option v-for="lang in languages" :key="lang.id" :value="lang.id">{{ lang.name }}</option>
      </select>
    </div>

    <!-- وارد کردن تعداد سطر و ستون -->
    <div class="mb-6 w-full max-w-md">
      <input v-model="timerDuration" type="number" placeholder="مدت زمان تایمر (میلی‌ثانیه)" class="bg-gray-800 text-white p-2 rounded-lg w-full mb-4" />
      <input v-model="rows" type="number" placeholder="تعداد سطر" class="bg-gray-800 text-white p-2 rounded-lg w-full mb-4" />
      <input v-model="columns" type="number" placeholder="تعداد ستون" class="bg-gray-800 text-white p-2 rounded-lg w-full mb-4" />
     <!-- <select v-model="transitionName" class="bg-gray-800 text-white p-2 rounded-lg w-full">
        <option value="rotate-zoom">Rotate Zoom</option>
        <option value="fade">Fade</option>
        <option value="slide">Slide</option>
        <option value="bounce">Bounce</option>
        <option value="flip">Flip</option>
        <option value="rotate">Rotate</option>
        <option value="zoom">Zoom</option>
        <option value="Nothing">بدون افکت</option>
      </select>-->
    </div>

    <!-- دکمه‌های منوها -->
    <div class="grid grid-cols-1 gap-4 w-full max-w-md">
      <button v-for="menu in shop.screenMenus" 
              :key="menu.id" 
              @click="selectMenu(menu.id)" 
              class="bg-yellow-600 hover:bg-yellow-500 text-white py-4 px-6 rounded-lg">
        {{ menu.name }}
      </button>
    </div>
    
  </div>
</template>

<script>
import { getLanguages, getstorebyslug } from "@/API/API";
import { useStore } from 'vuex';

export default {
  name: 'MenuSelection',
  data() {
    return {
      shop: {},
      languages: [],
      selectedLanguage: null,
      timerDuration: 5000, // مقدار پیش‌فرض مدت زمان تایمر
      rows: 2, // مقدار پیش‌فرض برای سطرها
      columns: 3, // مقدار پیش‌فرض برای ستون‌ها
      //transitionName: "rotate-zoom", // مقدار پیش‌فرض نوع انتقال
      baseurl: process.env.VUE_APP_APIDOMAIN
    };
  },
  async created() {
    const store = useStore();
    const shopSlug = this.$route.params.slug;
    this.shop = (await getstorebyslug(shopSlug, store.state.deflange)).data;
    this.languages = (await getLanguages(shopSlug)).data;
    this.selectedLanguage = store.state.deflange;
  },
  methods: {
    async changeLanguage() {
      const selectedLang = this.languages.find(lang => lang.id === this.selectedLanguage);
      this.shop = (await getstorebyslug(this.$route.params.slug, this.selectedLanguage)).data;
      this.$i18n.locale = selectedLang.name;
    },
    selectMenu(menuId) {
      // ارسال پارامترها به صفحه بعدی
      this.$router.push({
        path: `/shop/${this.$route.params.slug}/digitalmenu/${menuId}/${this.selectedLanguage}`,
        query: {
          timerDuration:this.timerDuration,
          rows: this.rows,
          columns: this.columns,
          //transitionName: this.transitionName
        }
      });
    }
  }
};
</script>

<style scoped>
select, input {
  width: 100%;
}

</style>
